export const LANGUAGE_CODES = [
  'de',
  'en',
  'es',
  'fr',
  'it',
  'ja',
  'nl',
  'pt',
] as const
export type LanguageCode = typeof LANGUAGE_CODES[number]

export type Language = {
  code: LanguageCode
  name: string
}

export const LANGUAGE_NAMES: Record<LanguageCode, string> = {
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  ja: '日本語',
  nl: 'Nederlands',
  pt: 'Português',
}
